import React, { Component } from "react";

import { Link } from "react-router-dom";

import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";

import Logo from "../assets/images/logo.png";
import Menu from "../assets/svg/menu-light.svg";

import MenuFunc from "./Menu";
import UpgradePopper from "./UpgradePopper";

import ABS from "../assets/workouts/abs.svg";
import ARM from "../assets/workouts/arm.svg";
import BALL from "../assets/workouts/ball.svg";
import BUTT from "../assets/workouts/butt.svg";
import CARDIO from "../assets/workouts/cardio.svg";
import FULL from "../assets/workouts/full.svg";
import KETTLE from "../assets/workouts/kettle.svg";
import LEG from "../assets/workouts/leg.svg";
import PILATES from "../assets/workouts/pilates.svg";
import STRETCH from "../assets/workouts/stretch.svg";

import { Helmet } from "react-helmet";

class WorkoutSelect extends Component {
  state = {
    menuToggled: false,
    upgradeToggled: false,
  };

  setmenuoff = (wot) => {
    this.setState({ menuToggled: wot });
  };

  setupgradeoff = (wot) => {
    this.setState({ upgradeToggled: wot });
  };

  clicked = () => {
    this.props.history.push({
      pathname: "/upgrade",
    });
  };
  componentDidMount() {}

  render() {
    const { categories, profile } = this.props;
    if (JSON.parse(localStorage.getItem('isPremium')) === true) {
        profile.isPremium = true;
    }

    const categories_list =
      categories && categories.length
        ? categories.map((category, index) => {
            return (
              <div
                key={category.name}
                className="grid-item"
                style={
                  category.isPremium && !profile.isPremium
                    ? { opacity: 0.7 }
                    : {}
                }
              >
                <Link
                  to={
                    !profile.isPremium && category.isPremium
                      ? "#"
                      : "/start-workout/" + category.name
                  }
                  onClick={(e) => {
                    if (!profile.isPremium && category.isPremium) {
                      this.setupgradeoff(true);
                    }
                  }}
                  style={
                    category.isPremium && !profile.isPremium
                      ? {
                          color: "white",
                          textDecoration: "none",
                          /*pointerEvents: "none",*/
                        }
                      : { color: "white", textDecoration: "none" }
                  }
                >
                  {/*
                 
                 <img
                    src={`https://firebasestorage.googleapis.com/v0/b/fittok-4619a.appspot.com/o/workout%2F${category.img}?alt=media`}
                    style={{ width: "60px", borderRadius: "3px" }}
                    alt={category.name}
                  />
                 
                 */}

                  <img
                    src={
                      category.name === "abs"
                        ? ABS
                        : category.name === "arm"
                        ? ARM
                        : category.name === "ball"
                        ? BALL
                        : category.name === "butt"
                        ? CARDIO
                        : category.name === "cardio"
                        ? BUTT
                        : category.name === "full"
                        ? FULL
                        : category.name === "kettle"
                        ? KETTLE
                        : category.name === "leg"
                        ? LEG
                        : category.name === "pilates"
                        ? PILATES
                        : category.name === "stretch"
                        ? STRETCH
                        : null
                    }
                    style={{ width: "60px", borderRadius: "3px" }}
                    alt={category.name}
                  />

                  <br />
                  <font
                    style={{
                      textAlign: "center",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                  >
                    {category.name.toUpperCase()}{" "}
                    {category.isPremium ? (
                      <span
                        style={{
                          fontSize: "15px",
                          color: "#EE1D52",
                        }}
                      >
                        Premium
                      </span>
                    ) : null}
                  </font>
                </Link>
              </div>
            );
          })
        : null;

    return (
      <div>
        <Helmet>
          <title>Sélectionner un entraînement</title>
          <meta
            name="description"
            content="Boxfit est l'application web ultime pour les entraînements à la maison avec plus de 390 vidéos, 10 catégories différentes d'exercice et fonctionnalités premium, et l'historique de vos entraînements & Radar de poids."
          />

          <meta property="og:url" content="https://www.boxfit-fitness.com/account" />
          <meta property="og:title" content="BoxFit" />
          <meta
            property="og:description"
            content="Boxfit est l'application web ultime pour les entraînements à la maison avec plus de 390 vidéos, 10 catégories différentes d'exercice et fonctionnalités premium, et l'historique de vos entraînements & Radar de poids."
          />
          <meta property="og:site_name" content="BoxFit" />
          <meta
            property="og:image"
            content="https://www.boxfit-fitness.com/images/sharer.png"
          />
          <meta property="og:type" content="profile" />
          <meta property="og:locale" content="en_US" />
        </Helmet>
        <div style={{ position: "relative" }}>
          <MenuFunc display={this.state.menuToggled} off={this.setmenuoff} />
          {this.state.upgradeToggled ? (
            <UpgradePopper
              clicked={this.clicked}
              off={this.setupgradeoff}
              startedtrial={profile.startedtrial}
            />
          ) : null}

          <div
            style={{
              zIndex: 999,
              position: "absolute",
              top: "15px",
              left: "20px",
            }}
          >
            <Link
              to={{
                pathname: "/",
                query: {
                  fromMenu: true,
                },
              }}
            >
              <img src={Logo} alt="logo" style={{ maxHeight: "45px" }}></img>
            </Link>
          </div>

          <div
            style={{
              position: "absolute",
              top: "25px",
              right: "22px",
              zIndex: 999,
            }}
            onClick={() => {
              this.setmenuoff(true);
            }}
          >
            <img src={Menu} alt="logo" style={{ maxHeight: "25px" }}></img>
          </div>
        </div>

        <div
          className="Screen"
          style={
            {
              /* height: "800px",
            width: "450px",
            borderRadius: "20px",
            boxShadow: "2px 2px 120px rgba(255, 255, 255, 0.15)",
            backgroundColor: "#000",*/
            }
          }
        >
          <h2 style={{ padding: "60px 25px 0px 25px" }}>Sélectionner un entraînement</h2>

          <div className="grid-container">{categories_list}</div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const categories = state.firestore.ordered["categories"];
  let category = categories ? categories : [];
  if (JSON.parse(localStorage.getItem('isPremium')) === true) {
    state.firebase.profile.isPremium = true;
  }
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile,
    categories: category,
  };
};

export default compose(
  connect(mapStateToProps, null),
  firestoreConnect((props) => [
    {
      collection: "categories",
    },
  ])
)(WorkoutSelect);
